//import '../node_modules/ajv/dist/ajv.bundle';
import Ajv from "ajv";
import defineFormatMinimumKeywords from "ajv-keywords/keywords/formatMinimum";
import defineFormatMaximumKeywords from "ajv-keywords/keywords/formatMaximum";

function _validateSchema(schema, data, options, inspection) {
	let ajv = defineFormatMaximumKeywords(defineFormatMinimumKeywords(new Ajv(options)));

	if (inspection != undefined) {
		ajv.addKeyword('validationFunc', {
			validate: function (schema, data, parentSchema, path, parentData, propertyName, rootData) {
				if (typeof schema === 'string' && schema != "") {
					const eval2 = eval;
					//this is workaround for rollup (https://github.com/rollup/rollup/wiki/Troubleshooting#avoiding-eval)
					const func = schema ? eval2("(" + schema + "\n)") : null;
					if (func) {
						const funcResult = func(inspection, parentData);
						return funcResult;
					}
				}
				return true;
			},
			errors: false
		});
	}

	let validate = ajv.compile(schema);
	let valid = validate(data);

	return { valid, errors: validate.errors };
}

export function validateSchemaAll(schema, data) {
	const options = { allErrors: true };

	return _validateSchema(schema, data, options, data);
}

export function validateSchemaPart(schema, data, insp) {
	const options = { allErrors: true };

	return _validateSchema(schema, data, options, insp);
}

export function applyDefaults(schema, data) {
	const options = { allErrors: true, useDefaults: true };

	return _validateSchema(schema, data, options);
}
